export default function leadPopup() {
    return {
        open: false,
        closed: false,

        init() {
            const dismissed = this.getCookie('leadPopupClosed');

            if (!dismissed) {
                setTimeout(() => {
                    this.open = true;
                }, 5000);
            } else {
                this.closed = true;
            }
        },

        close() {
            this.open = false;
            this.closed = true;
            this.setCookie('leadPopupClosed', '1', 30);
        },

        openPopup() {
            this.open = true;
        },

        setCookie(name, value, days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 86400000));
            document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
        },

        getCookie(name) {
            return document.cookie
                .split('; ')
                .find(row => row.startsWith(name + '='))
                ?.split('=')[1] || null;
        }
    }
}
